import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const suspendOperator = async (id: string, suspendReason: string) => {
  return await mutationExecute({
    variables: {
      id,
      suspendReason,
    },
    mutation: graphql(`
      mutation SuspendOperator($id: String!, $suspendReason: String!) {
        suspendOperator(id: $id, suspendReason: $suspendReason) {
          id
          firstName
          lastName
          email
          phoneNumber
          textNumber
          language1
          language2
          workerSid
          departments
          slackId
          slackWebHook
          slackAlertWebHook
          defaultType
          isDefaultOnly
          closedAt
          slingUserId
          isRehireEligible
          suspendedAt
          isSuspended
          isRecordAllCalls
          isEnableRegFlowView
        }
      }
    `),
  });
};
